import { Input } from "@chakra-ui/react";
import React from "react";

function FormInput({ type, name, placeholder, onChange, value, onBlur, id ,...ber}) {
  return (
    <>
      <Input
        type={type}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        id={id}
        {...ber}
      />
    </>
  );
}

export default FormInput;
